// src/pages/analytics/ReturnIndexPage/delegatePerformanceColumns.js
import React from 'react';
import { Typography, Progress, Tooltip } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const delegatePerformanceTableColumns = () => [
    {
        title: 'Délégué',
        dataIndex: 'delegateName',
        key: 'delegateName',
        sorter: (a, b) => (a.delegateName || '').localeCompare(b.delegateName || ''),
        fixed: 'left',
        width: 200,
    },
    {
        title: 'Médecins Ciblés',
        dataIndex: 'physiciansTargeted',
        key: 'physiciansTargeted',
        align: 'center',
        width: 150,
        sorter: (a, b) => (a.physiciansTargeted || 0) - (b.physiciansTargeted || 0),
        render: (text) => text === 'Erreur' ? <Text type="danger">Erreur</Text> : (text ?? 0),
    },
    {
        title: 'Médecins avec Indice ≥ 66%',
        dataIndex: 'physiciansAbove66',
        key: 'physiciansAbove66',
        align: 'center',
        width: 200,
        sorter: (a, b) => (a.physiciansAbove66 || 0) - (b.physiciansAbove66 || 0),
        render: (text) => text === 'Erreur' ? <Text type="danger">Erreur</Text> : (text ?? 0),
    },
    {
        title: 'Taux Médecins Performants (%)',
        dataIndex: 'performanceRate',
        key: 'performanceRate',
        align: 'center',
        width: 220,
        sorter: (a, b) => (a.performanceRate ?? -1) - (b.performanceRate ?? -1),
        render: (percentage) => {
            if (percentage === null || percentage === undefined) {
                return <Text type="secondary">N/A</Text>;
            }
            if (percentage === 'Erreur') {
                return <Text type="danger">Erreur</Text>;
            }

            const percentValue = parseFloat(percentage.toFixed(1));
            let progressBarColor;
            let status = 'normal';
            let icon = null;

            if (percentValue < 66) {
                progressBarColor = '#ff4d4f'; status = 'exception'; icon = <ArrowDownOutlined />;
            } else if (percentValue < 75) {
                progressBarColor = '#1677ff'; status = 'normal'; // Icone neutre ou pas d'icône
            } else { // >= 75%
                progressBarColor = '#52c41a'; status = 'success'; icon = <ArrowUpOutlined />;
            }

            return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Progress
                        percent={percentValue}
                        status={status}
                        strokeColor={progressBarColor}
                        showInfo={false}
                        style={{ flexGrow: 1, marginRight: 8 }}
                    />
                    <Text style={{ color: progressBarColor, fontWeight: 'bold', minWidth: '55px', textAlign: 'right' }}>
                        {icon} {percentValue}%
                    </Text>
                </div>
            );
        },
    },
];